import { z } from 'zod';
import { taxStatusParser } from '#validation/billing/parsers';
export const taxInfoSchema = z.object({
    taxId: z.string().optional(),
    taxStatus: taxStatusParser,
});
